export default __webpack_public_path__ + "static/gta_roofing_1-b6479b67eb12a0c284c28cc8d9124c73.jpg";